import React from "react";
import "./style.css";

const LogoBanner = () => {
  const handleWhatsAppClick = () => {
    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-667242866/rungCOCk-IUYEMnKwpAp",
      });
    }
  };

  return (
    <>
      <section className="banner_section" id="home_sec">
        <div className="banner-content">
          <div
            style={{
              textAlign: "center",
              color: "white",
              maxWidth: "750px",
              padding: "10px",
              margin: "20px",
              background: "rgba(0,0,0,0.45)",
              borderRadius: "20px",
              // backdropFilter: "blur(10px)",
            }}
          >
            <h1
              style={{
                fontSize: "clamp(32px, 5vw, 56px)",
                fontWeight: "700",
                marginBottom: "20px",
                lineHeight: "1.2",
              }}
            >
              Woven Patch Premium
            </h1>
            <p
              style={{
                fontSize: "clamp(16px, 2vw, 20px)",
                lineHeight: "1.6",
                marginBottom: "30px",
              }}
            >
              Logo woven atau di sebut patch woven yang di bentuk presisi dengan
              mesin laser cutting, untuk seragam, fashion brand, dan seragam
              perusahaan.
            </p>

            <div
              style={{
                display: "flex",
                gap: "20px",
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              <a
                href="https://api.whatsapp.com/send?phone=6282188883321&text=Hallo%20Mina%20Label!%20Saya%20Ingin%20Ingin%20bertanya%20tentang%20pembuatan%20logo%20woven."
                target="_blank"
                rel="noopener noreferrer"
                className="btn puprple_btn"
                style={{
                  padding: "15px 35px",
                  fontSize: "16px",
                }}
                onClick={handleWhatsAppClick}
              >
                Konsultasi Gratis
              </a>
              <a
                href="/logo"
                className="btn white_btn"
                style={{
                  padding: "15px 35px",
                  fontSize: "16px",
                  background: "white",
                  color: "#667eea",
                }}
              >
                Lihat Keunggulan
              </a>
            </div>
            <div
              className="banner-stats"
              style={{
                marginTop: "40px",
                display: "flex",
                justifyContent: "center",
                gap: "40px",
                flexWrap: "wrap",
              }}
            >
              <div>
                <div
                  style={{
                    fontSize: "32px",
                    fontWeight: "700",
                    color: "#f5576c",
                  }}
                >
                  100+
                </div>
                <div style={{ fontSize: "14px", opacity: 0.9 }}>
                  Perusahaan Percaya
                </div>
              </div>
              <div>
                <div
                  style={{
                    fontSize: "32px",
                    fontWeight: "700",
                    color: "#f5576c",
                  }}
                >
                  3-4 Hari
                </div>
                <div style={{ fontSize: "14px", opacity: 0.9 }}>
                  Proses Cepat
                </div>
              </div>
              <div>
                <div
                  style={{
                    fontSize: "32px",
                    fontWeight: "700",
                    color: "#f5576c",
                  }}
                >
                  42+ Tahun
                </div>
                <div style={{ fontSize: "14px", opacity: 0.9 }}>Pengalaman</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LogoBanner;
